
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle/[...vehicle]",
      function () {
        return require("private-next-pages/vehicle/[...vehicle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle/[...vehicle]"])
      });
    }
  